import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "nav nav-tabs" }
const _hoisted_2 = { class: "nav-item" }
const _hoisted_3 = { class: "nav-item" }
const _hoisted_4 = {
  key: 0,
  class: "nav-item"
}
const _hoisted_5 = {
  key: 1,
  class: "nav-item"
}
const _hoisted_6 = {
  key: 2,
  class: "nav-item"
}
const _hoisted_7 = { class: "nav-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("ul", _hoisted_1, [
      _createElementVNode("li", _hoisted_2, [
        _createVNode(_component_router_link, {
          to: "/vault/transactions",
          class: "nav-link",
          "active-class": "active"
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createElementVNode("i", { class: "fas fa-random me-1" }, null, -1),
            _createTextVNode(" Transacciones", -1)
          ]))]),
          _: 1
        })
      ]),
      _createElementVNode("li", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: "/vault/system-withdrawals",
          class: "nav-link",
          "active-class": "active"
        }, {
          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
            _createElementVNode("i", { class: "fas fa-sign-out-alt me-1" }, null, -1),
            _createTextVNode(" Retiros", -1)
          ]))]),
          _: 1
        })
      ]),
      (_ctx.canCreateWithdrawal)
        ? (_openBlock(), _createElementBlock("li", _hoisted_4, [
            _createVNode(_component_router_link, {
              to: "/vault/create-withdrawal",
              class: "nav-link",
              "active-class": "active"
            }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createElementVNode("i", { class: "fas fa-plus-circle me-1" }, null, -1),
                _createTextVNode(" Nuevo Retiro", -1)
              ]))]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (_ctx.canApproveWithdrawals)
        ? (_openBlock(), _createElementBlock("li", _hoisted_5, [
            _createVNode(_component_router_link, {
              to: "/vault/pending-withdrawals",
              class: "nav-link",
              "active-class": "active"
            }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createElementVNode("i", { class: "fas fa-exclamation-circle me-1" }, null, -1),
                _createTextVNode(" Retiros Pendientes", -1)
              ]))]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (_ctx.canCreateWithdrawal)
        ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
            _createVNode(_component_router_link, {
              to: "/vault/address-book",
              class: "nav-link disabled",
              "active-class": "active"
            }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                _createElementVNode("i", { class: "fas fa-address-book me-1" }, null, -1),
                _createTextVNode(" Directorio", -1)
              ]))]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("li", _hoisted_7, [
        _createVNode(_component_router_link, {
          to: "/vault/addresses",
          class: "nav-link",
          "active-class": "active"
        }, {
          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
            _createElementVNode("i", { class: "fas fa-qrcode me-1" }, null, -1),
            _createTextVNode(" Direcciones", -1)
          ]))]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_router_view)
    ])
  ]))
}